import request from '@/utils/request';
import { uuid } from 'vue-uuid'
import { obj2query } from '@/utils'
import { getToken } from '@/utils/auth'

export function transactionSearch(data){ 
  return request({
    url: '/api/firewall/transactions/search',
    method: 'post',
    data
  })
}

export function getTransactionID(transactionID) { 
  return request({
    url: `/api/firewall/transactions/${transactionID}`,
    method: 'get'
  })
}

export function putTransactionID(transactionID, data) { 
  data.idempotency = uuid.v1()
  return request({
    url: `/api/firewall/transactions/${transactionID}`,
    method: 'put',
    data
  })
}

export function getTransactionIDComment(transactionID) { 
  return request({
    url: `/api/firewall/transactions/${transactionID}/comment`,
    method: 'get',
  })
}
export function postTransactionIDComment(transactionID, data) { 
  data.idempotency = uuid.v1()
  return request({
    url: `/api/firewall/transactions/${transactionID}/comment`,
    method: 'post',
    data
  })
}
export function updateTransactionCommentByUID(transactionID, commentUID, data) { 
  data.idempotency = uuid.v1()
  return request({
    url: `/api/firewall/transactions/${transactionID}/comment/${commentUID}`,
    method: 'put',
    data
  })
}
export function deleteTransactionCommentByUID(transactionID, commentUID) { 
  return request({
    url: `/api/firewall/transactions/${transactionID}/comment/${commentUID}`,
    method: 'delete'
  })
}
export function postTransactionIDAdditionalComment(transactionID, data) {
  data.idempotency = uuid.v1()
  return request({
    url: `/api/firewall/transactions/${transactionID}/additional-commentary`,
    method: 'post',
    data
  })
}
export function getTransactionIDAdditionalComment(transactionID) {
  return request({
    url: `/api/firewall/transactions/${transactionID}/additional-commentary`,
    method: 'get',
  })
}
export function updateTransactionIDAdditionalCommentByUID(transactionID, commentUID, data) { 
  data.idempotency = uuid.v1()
  return request({
    url: `/api/firewall/transactions/${transactionID}/additional-commentary/${commentUID}`,
    method: 'put',
    data
  })
}
export function deleteTransactionIDAdditionalCommentByUID(transactionID, commentUID) { 
  return request({
    url: `/api/firewall/transactions/${transactionID}/additional-commentary/${commentUID}`,
    method: 'delete'
  })
}
export function postTransactionIDCheckSarReport(transactionID, data) { 
  data.idempotency = uuid.v1()
  return request({
    url: `/api/firewall/transactions/${transactionID}/check/sar-report`,
    method: 'post',
    data
  })
}
export function postTransactionIDCheckSarIdentified(transactionID, data) {
  data.idempotency = uuid.v1()
  return request({
    url: `/api/firewall/transactions/${transactionID}/check/other-redflags-identified`,
    method: 'post',
    data
  })
}

export function getMedia(plusuid, filename) { 
  return request({
    url: `/api/firewall/media/${plusuid}/${filename}`,
    method: 'get'
  })
}

export function getTransactionIDdocument(transactionID) { 
  return request({
    url: `/api/firewall/transactions/${transactionID}/document`,
    method: 'get'
  })
}

export function postTransactionIDdocument(transactionID, data) { 
  return request({
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    url: `/api/firewall/transactions/${transactionID}/document`,
    method: 'post',
    data
  })
}

export function deleteTransactionIDdocument(transactionID, documentID) { 
  return request({
    url: `/api/firewall/transactions/${transactionID}/document/${documentID}`,
    method: 'delete'
  })
}

export function getTransactionExcel(query, filename) {
  query.access_token = getToken()
  const baseURL = process.env.VUE_APP_SERVER_BASE_API
  const link = document.createElement('a')
  link.href = `${baseURL}/api/firewall/transactions/exportexcel${obj2query(query)}`;
  if (filename) {
    link.download = filename
  }
  link.click()
}

export function reportFirewallProfile(transactionID) {
  const baseURL = process.env.VUE_APP_SERVER_BASE_API
  const link = document.createElement('a')
  const token = getToken()
  link.href = `${baseURL}/api/firewall/transactions/${transactionID}/export-profile?token=${token}`
  link.click()
}

export function getFirewallSettingAutoCase() { 
  return request({
    url: `/api/firewall/transactions/setting/autocase`,
    method: 'get'
  })
}

export function postFirewallSettingAutoCase(data) { 
  return request({
    url: `/api/firewall/transactions/setting/autocase`,
    method: 'post',
    data
  })
}